enum VerificationOperation{
  Register = 'register',
  Profile = 'changeProfile',
  ResetPassword = 'resetPassword',
  SmsAuth = 'smsAuth'
}

export default VerificationOperation
